module.exports = __webpack_public_path__ + "static/media/lora_modbus.a3cbe856.md";